import { Grid, Typography } from '@material-ui/core';
import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';

import QCXFormStepWizard from '../../../../../shared-components/form-step-wizard/QCXFormStepWizard';

import QCXSelectPortoAeroportoAutocomplete from '../../../../../shared-components/select-porto-aeroporto/QCXSelectPortoAeroportoAutocomplete';
import InputWithCleanButton from '../../../../../components/declaracao-importacao/inputWithCleanButton/InputWithCleanButton';
import QCXFinalAlternativeCurrencyField from '../../../../../shared-components/final-currency-field/QCXFinalAlternativeCurrencyField';
import QCXSelectMoedaAutocomplete from '../../../../../shared-components/final-select-moeda-field/QCXSelectMoedaAutocomplete';
import QCXFinalDatePickerField from '../../../../../shared-components/final-date-picker-field/QCXFinalDatePickerField';
import QCXFinalTextField from '../../../../../shared-components/final-text-field/QCXFinalTextField';
import QCXFinalMultilineTextField from '../../../../../shared-components/final-text-field/QCXFinalMultilineTextField';
import QCXSelectTransportadorInternacionalAutocomplete from '../../../../../shared-components/select-transportador-internacional/QCXSelectTransportadorInternacionalAutocomplete';
import QCXSelectPortoAeroportoLocalOrigemAutocomplete from '../../../../../shared-components/select-porto-aeroporto/QCXSelectPortoAeroportoLocalOrigemAutocomplete';
import QCXSelectPortoAeroportoLocalDestinoAutocomplete from '../../../../../shared-components/select-porto-aeroporto/QCXSelectPortoAeroportoLocalDestinoAutocomplete';
import QCXSelectClienteAutocomplete from '../../../../../shared-components/final-select-cliente-field/QCXSelectClienteAutocomplete';


export default function TarifarioMaritimoDataForm({
  initialValues,
  handleSubmit,
  isConsult,
  isUpdate,
  controlComponentProps,
  authInfo = {},
  requiredRoles = [],
}) {
  const { t } = useTranslation();

  const camposTarifas = [
    { id: 'numeric-decimal-20dry-field', name: 'dry20', label: "20' Dry" },
    { id: 'numeric-decimal-40dry-field', name: 'dry40', label: "40' Dry" },
    { id: 'numeric-decimal-40highcubic-field', name: 'tarifa40HighCubic', label: "40' High Cubic" },
    { id: 'numeric-decimal-20graneleiro-field', name: 'graneleiro20', label: "20' Graneleiro" },
    { id: 'numeric-decimal-20flatrack-field', name: 'flatRack20', label: "20' Flat Rack" },

    { id: 'numeric-decimal-40flatrack-field', name: 'flatRack40', label: "40' Flat Rack" },
    { id: 'numeric-decimal-tank-field', name: 'tank', label: 'Tank' },
    { id: 'numeric-decimal-20opentop-field', name: 'openTop20', label: "20' Open Top" },
    { id: 'numeric-decimal-40opentop-field', name: 'openTop40', label: "40' Open Top" },
    { id: 'numeric-decimal-20reefer-field', name: 'reefer20', label: "20' Reefer" },

    { id: 'numeric-decimal-40reefer-field', name: 'reefer40', label: "40' Reefer" },
    { id: 'numeric-decimal-20nor-field', name: 'nor20', label: "20' NOR" },
    { id: 'numeric-decimal-40nor-field', name: 'nor40', label: "40' NOR" },
    { id: 'numeric-decimal-20plataforma-field', name: 'plataforma20', label: "20' Plataforma" },
    { id: 'numeric-decimal-40plataforma-field', name: 'plataforma40', label: "40' Plataforma" },
  ];

  return (
    <QCXFormStepWizard
      initialValues={initialValues}
      onSubmit={handleSubmit}
      controlComponentProps={controlComponentProps}
      authInfo={authInfo}
      requiredRoles={requiredRoles}
    >
      {({ values }) => (
        <>
          <Grid container spacing={2} style={{ marginTop: '1rem' }}>
            <Grid item xs={6} sm={6} md={6}>
              <InputWithCleanButton>
                <QCXSelectPortoAeroportoLocalOrigemAutocomplete
                  id="select-field-local-condicao-venda"
                  key="select-field-local-condicao-venda"
                  name="origem.id"
                  label="Origem"
                  disabled={isConsult}
                  initialValues={values}
                  required
                />
              </InputWithCleanButton>
            </Grid>

            <Grid item xs={6} sm={6} md={6}>
              <InputWithCleanButton>
                <QCXSelectPortoAeroportoLocalDestinoAutocomplete
                  id="select-field-local-condicao-venda-destino"
                  key="select-field-local-condicao-venda-destino"
                  name="destino.id"
                  label="Destino"
                  disabled={isConsult}
                  initialValues={values}
                  required
                />
              </InputWithCleanButton>
            </Grid>

            <Grid item xs={12} sm={3} md={3} lg={3}>
              <QCXSelectClienteAutocomplete
                id="autocomplete-select-importador-field"
                key="autocomplete-select-importador-field"
                name="cliente.id"
                label='Cliente'
                filter={{
                  importador: true,
                }}
                initialValues={values}
                disabled={isConsult}
                required
              />
            </Grid>

            <Grid item xs={6} sm={3} md={3}>
              <QCXSelectTransportadorInternacionalAutocomplete
                id="autocomplete-select-agente-transportador-field"
                key="autocomplete-select-agente-transportador-field"
                name="transportadorInternacional"
                label="Armador"
                initialValues={values}
                disabled={isConsult}
                maritimoOnly
              />
            </Grid>

            <Grid item xs={3} sm={3} md={3}>
              <QCXFinalTextField
                id="select-field-servico-seguro"
                key="select-field-servico-seguro"
                name="servico"
                label="Serviço / Rota"
                disabled={isConsult}
                initialValues={values}
              />
            </Grid>

            <Grid item xs={3} sm={3} md={3}>
              <QCXFinalDatePickerField
                id="date-picker-field-data-registro"
                key="date-picker-field-data-registro"
                label="Validade"
                name="atributosAdicionais.dataRegistroSiscomex"
                disabled={isConsult}
              />
            </Grid>

            <Grid item xs={12}>
              <Grid container spacing={2}>
                {camposTarifas.map(campo => (
                  <Grid item xs={12} sm={6} md={3} key={campo.id}>
                    <QCXFinalAlternativeCurrencyField
                      id={campo.id}
                      name={campo.name}
                      label={campo.label}
                      disabled={isConsult}
                      scale={2}
                    />
                  </Grid>
                ))}
              </Grid>
            </Grid>

            <Grid item xs={6} sm={6} md={6}>
              <QCXSelectMoedaAutocomplete
                id="select-field-moeda-seguro"
                key="select-field-moeda-seguro"
                name="moeda.id"
                label="Moeda"
                disabled={isConsult}
                initialValues={values}
              />
            </Grid>

            <Grid item xs={6} sm={6} md={6}>
              <QCXFinalTextField
                id="text-field-numero-transmissao"
                key="text-field-numero-transmissao"
                label="Transit Time"
                name="transitTime"
                disabled={isConsult}
              />
            </Grid>
          </Grid>
        </>
      )}
    </QCXFormStepWizard>
  );
}
